/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ValidateInvitationQueryResponse, ValidateInvitationPathParams, ValidateInvitation400, ValidateInvitation401, ValidateInvitation403, ValidateInvitation404, ValidateInvitation409, ValidateInvitation500 } from "../../types/staffController/ValidateInvitation.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { validateInvitation } from "../../client/staffController/validateInvitation.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const validateInvitationQueryKey = (token: ValidateInvitationPathParams["token"] | undefined) => [{ url: '/api/invitations/validate/:token', params: {token:token} }] as const

export type ValidateInvitationQueryKey = ReturnType<typeof validateInvitationQueryKey>

export function validateInvitationQueryOptions(token: ValidateInvitationPathParams["token"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = validateInvitationQueryKey(token)
        return queryOptions<ValidateInvitationQueryResponse, ResponseErrorConfig<ValidateInvitation400 | ValidateInvitation401 | ValidateInvitation403 | ValidateInvitation404 | ValidateInvitation409 | ValidateInvitation500>, ValidateInvitationQueryResponse, typeof queryKey>({
         enabled: !!(token),
         queryKey,
         queryFn: async ({ signal }) => {
            return validateInvitation(token!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Validate invitation token
 * {@link /api/invitations/validate/:token}
 */
export function useValidateInvitation<TData = ValidateInvitationQueryResponse, TQueryData = ValidateInvitationQueryResponse, TQueryKey extends QueryKey = ValidateInvitationQueryKey>(token: ValidateInvitationPathParams["token"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ValidateInvitationQueryResponse, ResponseErrorConfig<ValidateInvitation400 | ValidateInvitation401 | ValidateInvitation403 | ValidateInvitation404 | ValidateInvitation409 | ValidateInvitation500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? validateInvitationQueryKey(token)
         

         const query = useQuery({
          ...validateInvitationQueryOptions(token, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ValidateInvitation400 | ValidateInvitation401 | ValidateInvitation403 | ValidateInvitation404 | ValidateInvitation409 | ValidateInvitation500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}